import { useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import { ConfigurationType } from 'data/types';
import { useMemo } from 'react';
import { buildConfigurationThumbnail } from 'utils/configuration-thumbnail';

type ConfigurationZoneThumbnailProps = Readonly<{
  configuration: ConfigurationType;
  compact?: boolean;
}>;

export default function ConfigurationZoneThumbnail({
  configuration,
  compact
}: ConfigurationZoneThumbnailProps) {
  const { structure } = useAppSelector((state) => state.structure);

  const { rects, viewBox } = useMemo(
    () => buildConfigurationThumbnail(configuration, structure),
    [configuration, structure]
  );

  if (rects.length === 0) {
    return (
      <div
        className={clsx(
          'flex w-full items-center justify-center rounded-md border border-gray-200 bg-gray-50 text-xs text-gray-400',
          compact ? 'h-[72px]' : 'h-[110px]'
        )}
      >
        No zones
      </div>
    );
  }

  return (
    <svg
      viewBox={viewBox}
      preserveAspectRatio='xMidYMid meet'
      className={clsx(
        'pointer-events-none w-full rounded-md border border-gray-200 bg-gray-50',
        compact ? 'h-[72px]' : 'h-[110px]'
      )}
    >
      {rects.map((rect, index) => (
        <rect
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          x={rect.x}
          y={rect.y}
          width={rect.width}
          height={rect.height}
          fill={rect.color}
          fillOpacity={0.25}
          stroke={rect.color}
          strokeWidth={1}
          vectorEffect='non-scaling-stroke'
        />
      ))}
    </svg>
  );
}
